/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Out_Action_Create_Product_PnkInputs */

const vi_pkl_out_action_create_product_pnk = /** @type {(inputs: Pkl_Out_Action_Create_Product_PnkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu nhập lô sản phẩm`)
};

/**

* @param {Pkl_Out_Action_Create_Product_PnkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_out_action_create_product_pnk = /** @type {((inputs?: Pkl_Out_Action_Create_Product_PnkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Out_Action_Create_Product_PnkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_out_action_create_product_pnk(inputs)
});